<template>
  <div>
    <v-row>
      <v-col>
        <v-card
          class="d-flex flex-wrap justify-space-between"
        >
          <v-card
            class="pa-3"
            flat
          >
            <tw-cadastro-cliente
              @update="onUpdate"
            >
              <template v-slot:activator="{ on }">
                <v-btn color="primary" v-on="on" >
                  <v-icon>mdi-plus</v-icon>
                  Cadastrar cliente
                </v-btn>
              </template>
            </tw-cadastro-cliente>
          </v-card>
          <v-card
            class="pa-3 align-self-center"
            flat
          >
            <v-btn
              class="float-left"
              icon @click="getClientes">
              <v-icon center>mdi-refresh</v-icon>
            </v-btn>
            <tw-search-text
              label="Busque por um cliente"
              v-model="searchText"
              style="max-width: 400px; width: 350px;"
              :on-search="onChangeFilter"/>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
    <div v-if="loading">
      <tw-circular-loading/>
    </div>
    <div v-if="!loading && (!clientes || !clientes.total)"
         align="center"
         class="headline mb-5 mt-10">
<!--      Nenhuma cliente encontrado.-->
      <v-spacer></v-spacer>
      <tw-cadastro-cliente
        @update="onUpdate"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            color="green"
            dark
            v-on="on"
          >
            Clique aqui cadastrar seu primeiro cliente
          </v-btn>
        </template>
      </tw-cadastro-cliente>
    </div>
    <div v-if="!loading && clientes && clientes.total">
      <v-row dense>
        <v-col>
          <v-list two-line subheader>
            <template v-for="cliente in clientes.content">
              <tw-cliente-item
                :key="cliente.id"
                :cliente="cliente"
                @update="onUpdate"
                @remove="onRemove"
              />
            </template>
          </v-list>
        </v-col>
      </v-row>
      <div class="text-center">
        <v-pagination
          v-model="page"
          :length="pagesLimit"
          :total-visible="8"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ClienteService from '@/api/cliente-service';
import ClienteItem from '@/modules/cliente/ClienteItem.vue';
import paginationMixin from '@/mixins/pagination-mixin';
import CadastroCliente from './CadastroCliente.vue';

const LIMIT = 10;
const PAGE = 1;

export default {
  mixins: [paginationMixin],
  data: () => ({
    page: PAGE,
    pagesLimit: 1,
    searchText: null,
    loading: false,
    clientes: {
      content: [],
      total: 0,
    },
    listOptions: {
      page: PAGE,
      limit: LIMIT,
      offset: 0,
      filter: '',
      sort: 'nome',
      sortDesc: false,
    },
    optionsList: {
      page: PAGE,
      itemsPerPage: LIMIT,
      sortBy: '',
      sortDesc: false,
      multiSort: false,
    },
  }),
  created() {
    this.getClientes();
  },
  methods: {
    buildSearchFilter(filters) {
      if (!filters.searchText) {
        return '';
      }
      return `(nome like "%${filters.searchText.toLowerCase()}%" or email like "%${filters.searchText.toLowerCase()}%" or celular like "%${filters.searchText.toLowerCase()}%")`;
    },
    onChangeFilter() {
      this.listOptions.filter = this.buildSearchFilter({ searchText: this.searchText });
      this.resetPage();
      this.getClientes();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    onUpdate() {
      this.getClientes();
    },
    getClientes() {
      this.loading = true;
      this.listOptions.sort = 'nome';
      const {
        limit,
        offset,
      } = this.listOptions;
      ClienteService.list({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then(({ data }) => {
          this.clientes = data;
          this.setPagesLimit();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setPagesLimit() {
      this.pagesLimit = Math.ceil(this.clientes.total / LIMIT);
    },
    onChangeOptions() {
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getClientes();
    },
    onRemove(item) {
      this.loading = true;
      ClienteService.remove(item.id)
        .then(() => {
          this.$toast('Cliente removido com sucesso', { color: 'success' });
          this.getClientes();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: {
    twCadastroCliente: CadastroCliente,
    twClienteItem: ClienteItem,
  },
  watch: {
    page(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.optionsList.page = newValue;
      this.onChangeOptions();
    },
  },
};
</script>
